import MasonryGrid from '../components/MasonryGrid';
import ProductListItem from '../components/ProductListItem';
import Select from '../components/Select';

export default class StaticCollection {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    $('[data-collection-tags]').on('change', event => this.filterCollection(event));
    $('[data-collection-sorting]').on('change', event => this.sortCollection(event));
    this.$masonry = this.$el.find('[data-masonry-grid]');
    this.masonryGrid = null;

    this.productItems = $('.product-list-item');

    this.productListItems = this.productItems.map((index, product) =>
      new ProductListItem({el: product})
    );
    this.$collectionTags = this.$el.find('[data-collection-tags]');
    this.$collectionSorting = this.$el.find('[data-collection-sorting]');

    if (this.$collectionTags.length) {
      new Select({ el: this.$collectionTags });
    }

    if (this.$collectionSorting.length) {
      new Select({ el: this.$collectionSorting });
    }

    if (this.$masonry.length) {
      this.masonryGrid = new MasonryGrid({
        $el: this.$masonry,
        settings: {
          itemSelector: '.product-list-item',
          horizontalOrder: true,
        },
      });
    }
  }

  onSectionUnload() {
    this.remove();
  }

  remove() {
    if (this.masonryGrid) {
      this.masonryGrid.unload();
    }

    for (let i = 0; i < this.productListItems.length; i++){
      this.productListItems[i].remove();
    }

    $('[data-collection-tags]').off('change');
    $('[data-collection-sorting]').off('change');
  }

  filterCollection(event) {
    const $target = $(event.currentTarget);

    const tag = $target.val();
    const url = $target.data('url');

    if (tag === 'all') {
      window.location.href = `${window.Theme.routes.collections_url}/${url}`;
    } else {
      window.location.href = `${window.Theme.routes.collections_url}/${url}/${tag}`;
    }
  }

  sortCollection(event) {
    let search;
    const $target = $(event.currentTarget);

    const Sorting = {};
    Sorting.sort_by = $target.val();

    if ($target.closest('.select-wrapper').hasClass('vendor-collection')) {
      const currentSearch = location.search;
      const searchParts = currentSearch.split('&');

      for (let index = 0; index < searchParts.length; index++) {
        const part = searchParts[index];
        if (part.indexOf('sort_by') !== -1) {
          searchParts.splice(index, 1);
        }
      }

      search = searchParts.join('&');
      return location.search = `${search}&${jQuery.param(Sorting)}`;
    }
    return location.search = jQuery.param(Sorting);
  }
}
